<template>
  <div class="deadline" data-external="task-deadline">
    <div :class="['icon-container', { 'past-deadline': isOverdue }]">
      <FriedIcon :size="IconSize.Small" icon="alert-circle" />
    </div>
    <div class="deadline-text">
      <FriedH5>{{ getDeadline(fromMillis(deadline)) }}</FriedH5>
      <FriedParagraph :size="ParagraphSize.Small">{{ t('map_task_deadline') }}</FriedParagraph>
    </div>
  </div>
</template>
<script lang="ts">
import { computed, defineComponent } from 'vue';
import { DateTime } from 'luxon';
import { IconSize, ParagraphSize } from '@getaccept/fried-tofu';
import { useI18n } from 'vue-i18n';
import TaskHelper from '../helpers/task.helper';

export default defineComponent({
  props: {
    deadline: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    const { t } = useI18n();
    const isOverdue = computed(() => DateTime.now().toMillis() > props.deadline);

    return {
      getDeadline: TaskHelper.getDeadline,
      fromMillis: DateTime.fromMillis,
      isOverdue,
      ParagraphSize,
      IconSize,
      t,
    };
  },
});
</script>
<style lang="scss" scoped>
:deep(.paragraph.small) {
  color: var(--text-gray);
}

.deadline {
  display: flex;
  align-items: center;
  gap: var(--spacing-50);

  .icon-container {
    background: var(--gray-96);
    width: 2rem;
    height: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;

    &.past-deadline {
      background: var(--error-light);

      .svg-icon {
        color: var(--error-dark);
      }
    }
  }
}
</style>
